import React from 'react';
import {useState} from "react";
import { MiniProductReviews } from '@bepure/tarkin';
import { RegularProduct } from '@bepure/tarkin/dist/utils/cart';
import AddToCartBtn, { CartProduct } from './AddToCartBtn';
import PurchaseFrequencyDropdown from './PurchaseFrequencyDropdown';

declare const RECHARGE_PRODUCT_DATA: any;

interface Product extends Partial<RegularProduct> {
    unit_price: number;
    sale_price?: number;
    retail_price?: number;
    categories: Category[];
    isInStock: boolean;
    reviewSummary?: ProductReview;
}

interface Category {
    entityId: number;
    name: string;
    path: string;
}

export interface ProductReview {
    review_count: number;
    score: number;
}

interface ProductCardProps {
    product : Product;
}

const ProductCard = (props: ProductCardProps) => {
    const defaultImage = 'https://s3-ap-southeast-2.amazonaws.com/static.bepure.co.nz/Arwen/StoreImages/ImageUnavailable_660x660.gif';
    const [cancelNavigation, setCancelNavigation] = useState(false);
    const [subscriptionFrequency, setSubscriptionFrequency] = useState(0);
    const purchaseButtonText = subscriptionFrequency == 0 ? "Add to Cart" : "Subscribe now";
    const product = props.product;

    const stopNavigation = () => {
        setCancelNavigation(true);
    }
    const allowNavigation = () => {
        setCancelNavigation(false);
    }

    const onClickProduct = (product: Product) => {
        if(cancelNavigation){return}
        return (el: any) => {
            if (el.target.type !== 'button') {
                let product_url = (document.querySelector(`.product-urls[value="${product.sku}"]`) as HTMLInputElement)?.dataset?.url || '';
                if (product_url) {
                    window.location.href = product_url;
                } else {
                    window.location.href = `/store/product?sku=${product.sku}`
                }
            }
        };
    }

    const getCartProductObj = (product: Product): CartProduct => {
        const oneTimePurchaseProduct = {
            name: product.name ? product.name : '',
            unit_price: product.unit_price ? product.unit_price : 0,
            sku: product.sku ? product.sku : '',
            imageUrl: product.imageUrl ? product.imageUrl : '',
            id: product.productId ? product.productId : 0,
            variantId: product.variantId,
        }
        if(subscriptionFrequency != 0){
            return {
                ...oneTimePurchaseProduct,
                
                chargeIntervalFrequecy: RECHARGE_PRODUCT_DATA.find((x:any) => x.id === props.product.productId).subscriptions[0].charge_interval_frequency,
                orderIntervalFrequency: subscriptionFrequency,
                orderIntervalUnit: RECHARGE_PRODUCT_DATA.find((x:any) => x.id === props.product.productId).subscriptions[0].order_interval_unit
            }
        }

        else return oneTimePurchaseProduct
    }

    const discountedprice = (props.product.unit_price * 0.9).toFixed(2);
    const resetSubscriptionFrequency = () => {
        setSubscriptionFrequency(0);
    }
    return(
        <div className="product" key={product.sku} onMouseLeave={resetSubscriptionFrequency}>
            <div className="product__details_wrapper" onClick={onClickProduct(product)}>
                <div className={`product-image product-image${product.isNew ? '--new' : defaultImage}`}>
                    <img src={product.imageUrl} alt={product.name} />
                </div>
                <div className="product__inner-content">
                    <MiniProductReviews
                        numReviews={product?.reviewSummary?.review_count}
                        averageScore={product?.reviewSummary?.score || 0}
                        noText={true}
                        orange={true}
                    />
                    <div className="text product-name text--heading--second">{product.name}</div>
                    <div className="text product-description" dangerouslySetInnerHTML={product.description ? { __html: product.description } : { __html: '' }} />
                    
                    <div className="product-price">
                        {product.sale_price && subscriptionFrequency == 0 &&
                        <div className="strikeout space_5"> ${product.retail_price ? product.retail_price:""}</div>}

                        <div className="product-price__text">${product.unit_price} {localStorage.currency}</div>
                        {subscriptionFrequency != 0 &&
                            <img src ="https://s3.ap-southeast-2.amazonaws.com/static.bepure.co.nz/Arwen/Icons/DiscountTag_40x29.svg"></img>}
                    </div>

                    
                    
                </div>
                <div className="subscription-hover-content" onMouseEnter={stopNavigation} onMouseLeave={allowNavigation}>
                    <div className="product-price-subtext">
                    {subscriptionFrequency != 0  &&
                        <div>  {"$" + discountedprice + " from next order"}</div>}
                    </div>
                    { (RECHARGE_PRODUCT_DATA.find((x:any) =>x.id===product.productId).subscriptions.length !== 0) &&
                        <PurchaseFrequencyDropdown id={getCartProductObj(product).id} offerOneTimePurchase={true} setFrequencyState={setSubscriptionFrequency}></PurchaseFrequencyDropdown>
                    }
                    <AddToCartBtn 
                        sku={product.sku? product.sku : ''}
                        product={getCartProductObj(product)}
                        otherClasses={'btn--primary subscription-hover-content__button'} 
                        textOverride={purchaseButtonText}
                    />
                </div>

            </div>
                               
        </div>
    )
}

export default ProductCard;

